import React from "react"
import { AccordionButton, AccordionItem, Flex, Heading } from "@chakra-ui/react"

import Icon from "@app/components/Icon"

type Props = {
  children: any
  title: string
  style: string
  hasTopBorder?: boolean
  hasBottomBorder?: boolean
}

const AccordionGroupItemBase: React.FC<Props> = ({ children, title, style, hasTopBorder = true, hasBottomBorder = true }) => {
  const isProduct = style === "product"
  const isSkinSupport = style === "skin-support"
  const isGiftcard = style === "giftcard"

  return (
    <AccordionItem
      borderTopWidth={hasTopBorder ? "2px" : 0}
      borderBottomWidth={isSkinSupport ? "2px" : 0}
      _last={{ borderBottomWidth: hasBottomBorder ? (isGiftcard ? "1px" : "2px") : 0 }}
      {...(isGiftcard && {
        borderColor: "#D2D2D4",
        borderTopWidth: "1px",
      })}
    >
      {({ isExpanded }) => (
        <>
          <AccordionButton
            px={0}
            py={{ base: isProduct || isSkinSupport ? "20px" : "10px", xs: "20px" }}
            _hover={{ bgColor: "transparent" }}
          >
            <Flex alignItems="center" w="100%" paddingInline={isProduct ? "9px" : isSkinSupport ? "20px" : 0}>
              <Heading
                variant={isProduct || isSkinSupport ? "h3" : "heading22"}
                flex={1}
                fontWeight={isProduct || isSkinSupport ? 500 : 400}
                textAlign="left"
                color={isProduct || isSkinSupport ? "brand.darkBlue" : "brand.black"}
                className="gicffdsfs"
                {...(isGiftcard && {
                  fontFamily: "Larsseit",
                  fontWeight: 700,
                  lineHeight: "24px",
                  fontSize: "16px",
                })}
              >
                {title}
              </Heading>
              <Icon
                name={isExpanded ? "minus" : isProduct ? "plusProduct" : "plusFaq"}
                width={isExpanded ? (isProduct ? "12px" : "8px") : isProduct ? "12px" : "14px"}
                height={isExpanded ? "3px" : isProduct ? "12px" : "14px"}
              />
            </Flex>
          </AccordionButton>
          {children}
        </>
      )}
    </AccordionItem>
  )
}

export default React.memo(AccordionGroupItemBase)
